import { render } from "./DoctorView.vue?vue&type=template&id=472c71be&scoped=true"
import script from "./DoctorView.vue?vue&type=script&lang=js"
export * from "./DoctorView.vue?vue&type=script&lang=js"

import "./DoctorView.vue?vue&type=style&index=0&id=472c71be&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472c71be"]])

export default __exports__